import { ThemeComponent } from "@/theme/ThemeComponent";
import { OptionSelector } from "@/utils/OptionSelectors";
import { Component, Prop, Ref, SimpleEvent } from "@eastsideco/salvo-ts";

@Component
export class ProductOptionButtons extends ThemeComponent {
    @Prop name!: string;
    @Prop values!: string[];
    @Prop selected!: string|null;
    @Prop position!: number;

    @Ref input!: HTMLSelectElement;

    private valuesWithoutStock: string[] = [];
    private valuesWithoutVariant: string[] = [];

    private _onChange = new SimpleEvent<string|null>();
    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        this.$listen(this.input, 'change', (e) => {
            this.valueChanged();
        });
        this.valueChanged();
    }

    private valueChanged() {
        this.selected = this.input.value || null;
        this._onChange.dispatch(this.selected);
    }


    public updateBasedOnSelector(selector: OptionSelector) {
        this.valuesWithoutStock = selector.options[this.position - 1].values
            .filter((v) => v.outOfStock).map((v) => v.value);
        this.valuesWithoutVariant = selector.options[this.position - 1].values
            .filter((v) => !v.variantExists).map((v) => v.value);

        this.updateOptions();
    }

    private updateOptions() {
        for (const optionEl of this.input.options) {
            optionEl.label = optionEl.value;
            if (this.valuesWithoutStock.indexOf(optionEl.value) > -1){
                optionEl.label += ' - Out of stock';
            } else if (this.valuesWithoutVariant.indexOf(optionEl.value) > -1) {
                optionEl.label += ' - Not available';
            }
        }
    }
}

